import * as React from 'react';
import TooltipDto from './types/TooltipDto';
import { EntityDefinition } from 'types';
import TooltipPopover from './TooltipPopover';
import PopoverBody from 'reactstrap/lib/PopoverBody';
import { TooltipEditButton } from './TooltipEditButton';

interface TooltipWrapperProps {
	hideTooltip?: boolean;
	hasTooltipError: boolean;
	tooltipText: string;
	nameValue: string;
	isTooltipEditMode: boolean;
	tooltipData: { [name: string]: { fieldTooltip: TooltipDto; universalTooltip: TooltipDto } };
	entityDefinition: EntityDefinition;
	label: string;
}

export type ToolTipDataProps = {
	tooltipText?: string;
	nameValue?: string;
	tooltipData?: { [name: string]: { fieldTooltip: TooltipDto; universalTooltip: TooltipDto } };
	entityDefinition?: EntityDefinition;
	hasTooltipError?: boolean;
};

/**
 * Wrapper component for the tooltip button and popover
 *
 * @export
 * @param {TooltipWrapperProps} props
 * @returns
 */
export default function TooltipWrapper(props: TooltipWrapperProps) {
	const {
		hideTooltip = false,
		hasTooltipError,
		tooltipText,
		nameValue,
		isTooltipEditMode,
		tooltipData,
		entityDefinition,
		label,
	} = props;

	!hideTooltip && !hasTooltipError;

	if (hideTooltip || hasTooltipError) {
		return null;
	}

	return (
		<>
			{tooltipText && (
				<TooltipPopover name={nameValue}>
					<PopoverBody>{tooltipText}</PopoverBody>
				</TooltipPopover>
			)}

			{isTooltipEditMode ? (
				<div className="tooltip__item">
					<TooltipEditButton
						name={nameValue}
						label={label}
						tooltipData={tooltipData}
						entityDefinition={entityDefinition}
					/>
				</div>
			) : null}
		</>
	);
}
